import { useLang } from './LanguageContext';
import type { Lang } from './types';
import styles from './LanguageSwitcher.module.css';

type Option = {
  readonly lang: Lang;
  readonly label: string;
};

const OPTIONS: readonly Option[] = [
  { lang: 'ja', label: '日本語' },
  { lang: 'zh', label: '简体中文' },
];

/** Japanese / Simplified-Chinese toggle. Switching does not change the URL. */
export const LanguageSwitcher = (): JSX.Element => {
  const { lang, setLang } = useLang();

  return (
    <div className={styles.switcher} role="group" aria-label="Language / 语言">
      {OPTIONS.map((option, index) => (
        <span key={option.lang} className={styles.item}>
          {index > 0 && <span className={styles.divider} aria-hidden>/</span>}
          <button
            type="button"
            className={`${styles.option} ${lang === option.lang ? styles.active : ''}`}
            aria-pressed={lang === option.lang}
            onClick={() => setLang(option.lang)}
          >
            {option.label}
          </button>
        </span>
      ))}
    </div>
  );
};
